var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bsd bc-wht bw-02r bg-wht-op06 px-4 pt-405 pb-5 pr-2 rounded-lg position-relative"},[_vm._t("main")],2)}
var staticRenderFns = []

export { render, staticRenderFns }